import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import AnimatedOpportunityListItem from "app/pages/sales-intelligence/sub-modules/opportunities/components/list-items/OpportunityListItem/AnimatedOpportunityListItem";

export const StyledOrangeDot = styled.div`
    background: ${colorsPalettes.orange["400"]};
    width: 8px;
    height: 8px;
    border-radius: 50%;
`;

export const StyledOrangeDotWrapper = styled.div`
    margin-left: 4px;
`;

export const StyledCRMSyncLoadingWrapper = styled.div`
    padding-right: 16px;
`;

export const StyledCRMListItem = styled(AnimatedOpportunityListItem)`
    cursor: pointer;
`;
